const reorderUfs = (ufs: string[], selectedUf: string) => {
	if (!selectedUf || !ufs.includes(selectedUf)) return ufs;

	return [selectedUf, ...ufs.filter(uf => uf !== selectedUf)];
};

export {reorderUfs};
